import { postLogConsent } from '@amo/core/utils/requestsApi';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formValueSelector } from 'redux-form';
import { setReturnToRecapGpt, setStep } from '../../../../../redux/actions/app/ui/ui.actions';
import { getToken, getCanalDemandeTarifInit, getTypeMERInit } from '../../../../../redux/selectors/init/init.selectors';
import { getVehicule } from '../../../../../redux/selectors/vehicule/vehicule.selectors';
import { getUtmSource } from '../../../../../redux/selectors/ui/ui.selectors';
import { getStepBySlug } from '../../../../../utils/function';
import RecapGPT from './RecapGPT';

const selector = formValueSelector('devis-direct');

const mapStateToProps = (state) => {
    const personne = selector(state, 'DemandeTarif[ListePersonnes][0]') || {};
    const vehicule = selector(state, 'DemandeTarif[Vehicule]') || {};
    const antecedents = selector(state, 'DemandeTarif[Antecedents]') || {};
    const devoirConseil = selector(state, 'DemandeTarif[DevoirConseil]') || {};

    const police = selector(state, 'DemandeTarif[Police]') || {};

    return {
        vehiculeData: vehicule,
        vehiculeInfo: getVehicule(state),
        typeVehicule: selector(state, 'typeVehicule'),
        personne,
        antecedents,
        devoirConseil,
        police,
        token: getToken(state),
        canal: getCanalDemandeTarifInit(state),
        utm_source: getUtmSource(state),
        gptConsent: selector(state, 'gptConsent'),
        typeMER: getTypeMERInit(state),
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setStep,
            setReturnToRecapGpt,
        },
        dispatch,
    );

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { token, canal } = stateProps;
    const { setStep, setReturnToRecapGpt } = dispatchProps;

    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        submitConsent: () => {
            // Le TypeMER d'origine (AppGPT ou AgentConv) est conservé tel quel.
            return postLogConsent({
                token,
                canal: canal || 'GP',
                phone: null,
                email: null,
                phone_contact_consent: 'true',
                type: 'gpt',
            });
        },
        goToStepForEdit: (slug) => {
            setReturnToRecapGpt(true);
            setStep({ step: getStepBySlug(slug) });
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(RecapGPT);
